import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IProjectStatsFiltersStore } from '../filters/ProjectStatsFilters.store';
import { WorkPerformanceSection } from './WorkPerformanceSection';

export const WorkPerformanceSectionContainer = observer((): ReactElement => {
  const filtersStore = useInjection(IProjectStatsFiltersStore.$);

  return (
    <WorkPerformanceSection
      endDate={filtersStore.endDate}
      startDate={filtersStore.startDate}
    />
  );
});
